<script context="module">
    export const name = "large with text over image";
</script>

<script lang="ts">
    import Data from "@reperio-news/core.components/blocks/ContentItem/Data";
    import { stripTags } from "@reperio-news/core.components/includes/Helpers";
    import { z } from "zod";
    type Data = z.infer<typeof Data>;
    import { getContext } from "svelte";
    import ImageView from "@reperio-news/core.components/ImageView.svelte";

    export let data: Data = {};
</script>

{#if data && data.content}
    <a
        class="entry"
        href={data.content.url}
        title={stripTags(data.content.summary)}
    >
        {#if data.content.poster}
            <div class="image">
                <!-- request 2:1 to match the box (was 1200x780 into a
                     600px-tall box: a hidden second crop cut ~23% of it) -->
                <ImageView
                    src={data.content.poster}
                    crop={data.content.poster.crop}
                    width={1200}
                    height={600}
                    widths={[1200, 1000, 600, 300]}
                    heights={[600, 500, 300, 150]}
                    animatedQuality={45}
                    fit="cover"
                />
            </div>
        {/if}

        <div class="info">
            <div class="title">
                {@html stripTags(data.content.title, ["i", "b", "strong", "font"])}
            </div>
        </div>
    </a>
{/if}

<style lang="scss">
    :global(.blockContainer-width-full) {
        .entry {
            margin: 10px auto 10px auto;
        }
    }

    .entry {
        display: block;
        min-width: 300px;
        flex-grow: 1;
        color: inherit;
        margin: 10px;
        border: 1px solid #f1f1f1;
        color: #111;
        position: relative;

        .info {
            position: absolute;
            left: 0px;
            bottom: 0px;
            width: calc(100% - 40px);
            padding: 35px 20px 35px 20px;
            background-color: rgba(0, 0, 0, 0.65);
            color: #fff;
            .title {
                font-size: 20px;
                font-weight: bold;
            }
        }

        .image {
            min-width: 250px;
            /* box ratio matches the 1200x600 request — full-width desktop
               is near identical, narrower boxes scale instead of re-cropping */
            aspect-ratio: 2 / 1;
            height: auto;
            max-height: 600px;
            overflow: hidden;
            display: block;
        }
    }

    @media only screen and (max-width: 650px) {
        .entry {
            min-height: 350px;
            background-color: #524747;

            .image {
                height: auto;
            }
        }

        .co-1 {
            width: calc(100% - 30px);
        }
    }

    @media only screen and (max-width: 500px) {
        .entry {
            border-bottom: 4px solid #f1f1f1;
        }
    }
</style>
